export default (content) => {
	const tempWrapper = document.createElement("div");
	tempWrapper.className = "article-parse";
	tempWrapper.innerHTML = content;

	const hCards = tempWrapper.querySelectorAll(".h-card");
	for (let card of hCards) {
		const prevH2 = card.previousElementSibling;
		if (prevH2 && prevH2.tagName.toLowerCase() === "h2") {
			let hcardHTML = card.outerHTML;
			hcardHTML = hcardHTML.replace(/h5/gim, "h6");
			hcardHTML = hcardHTML.replace(/h4/gim, "h5");
			hcardHTML = hcardHTML.replace(/h3/gim, "h4");
			hcardHTML = hcardHTML.replace(/h2/gim, "h3");

			card.innerHTML = hcardHTML;
		}
	}
	return tempWrapper.innerHTML;
};
